import { Link } from 'react-router-dom';
import _ from 'lodash';


import './../../pages/properties/property.css'; // TODO Should we share this or move it!?

export const LandlordTiles = ({ companies }) => {

    const landLordLogoPath = landlord => {
        return landlord.logoPathIncSasToken;
    }

    const imageNotAvailableClass = (landlord) => {
        const result = "property product" + (landLordLogoPath(landlord) ? "" : " not-available");
        return result;
    }

    const imageStyle = (landlord) => {
        const unknown = { alignSelf: "center", width: "50%", backgroundImage: 'url(/assets/img/pos/unknown-house.png)' };
        const known = { alignSelf: "center", width: "50%", backgroundImage: `url(${landLordLogoPath(landlord)})` };
        return landLordLogoPath(landlord) ? known : unknown;
    }

    const getLandlords = () => {
        const landlords = _.sortBy(_.flatMap(companies, c => c.landlordsOrOwners), l => l.name);
        return landlords;
    };


    return (getLandlords() && getLandlords().map((landlord, i) => (

        <div key={`landlord-${landlord.id}-counter-${i}`} className="product-container" >
            <Link to={`/landlords/detail/${landlord.id}`} className={imageNotAvailableClass(landlord)}>
                <div className="img mt-20px" style={imageStyle(landlord)}></div>
                <div className="text">
                    <div className="property-description">{landlord.displayName}</div>
                    <div className="property-first-line">{landlord.phoneNumber}</div>
                    <div className="postcode">{landlord.email}</div>
                </div>
                {!landLordLogoPath(landlord) && (
                    <div className="not-available-text">
                        <div>Image Not Available</div>
                    </div>
                )}
            </Link>
        </div>
    )));
}